const chestsStyle = {
  card: {
    padding: 3,
    minHeight: 375,
    display: "flex",
    border: `3px solid #5251e5`,
    background: "rgba(37, 37, 63, 0.3)",
    borderRadius: 7,
    boxShadow: "0 0 29px 2px rgba(212, 218, 251, 0.5)",
  },
  button: {
    backgroundImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/button-purple.png)`,
    backgroundSize: "255px 109px",
    backgroundColor: "inherit",
    backgroundRepeat: "no-repeat",
    boxShadow: "none",
    position: "absolute",
    flexDirection: "column",
    border: "none",
    bottom: -92,
    right: -6,
    width: 255,
    height: 143,
    "&:hover,&:focus": {
      backgroundColor: "inherit",
      boxShadow: "none",
    },
    "&:hover > h3, &:hover > h6": {
      transform: "scale(1.1)",
      transition: "all .2s",
    },
  },
  buttonText: {
    marginLeft: -3.75,
  },
} as const;

export default chestsStyle;
